import { usePaymentMonths } from '../../hooks/usePayments';

interface MonthPickerProps {
    value: string;
    onChange: (ym: string) => void;
}

export default function MonthPicker({ value, onChange }: MonthPickerProps) {
    const { data: months } = usePaymentMonths();
    const list = months ?? (value ? [value] : []);

    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="px-3 py-2 text-sm border border-[#E6E9ED] rounded bg-white focus:outline-none focus:ring-2 focus:ring-[#1ABB9C]/20 focus:border-[#1ABB9C] transition"
        >
            {list.map((m) => (
                <option key={m} value={m}>{m}</option>
            ))}
        </select>
    );
}
